"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var android_player_1 = require("./android-player");
var android_input_1 = require("./android-input");
var android_info_1 = require("./android-info");
var android_capabilities_1 = require("./android-capabilities");
var android_message_listener_1 = require("./android-message-listener");
var android_lifecycle_1 = require("./android-lifecycle");
var android_deeplink_1 = require("./android-deeplink");
var android_container_updater_1 = require("./android-container-updater");
var AndroidDeviceFactory = (function () {
    function AndroidDeviceFactory(context) {
        if (context === void 0) { context = window; }
        this.context = context;
        this.initialised = false;
    }
    AndroidDeviceFactory.prototype.identifiers = function () {
        return [client_lib_js_player_addons_common_player_1.DeviceType.Android];
    };
    AndroidDeviceFactory.prototype.getInstance = function () {
        if (!this.initialised) {
            throw new Error('Android Device Factory was not initialised');
        }
        return this.device;
    };
    AndroidDeviceFactory.prototype.initialise = function () {
        return __awaiter(this, void 0, void 0, function () {
            var container, player, input, storage, deviceInfo, capabilities, lifecycle, deeplink, containerUpdater;
            var _this = this;
            return __generator(this, function (_a) {
                container = android_message_listener_1.AndroidMessageListener.getInstance(this.context);
                player = new android_player_1.AndroidPlayer(this.context, container);
                input = new android_input_1.AndroidInput(this.context);
                storage = new client_lib_js_player_addons_common_player_1.HTML5LocalStorage(this.context);
                deviceInfo = new android_info_1.AndroidInfo(this.context);
                capabilities = new android_capabilities_1.AndroidCapabilities();
                lifecycle = new android_lifecycle_1.AndroidLifecycle(this.context);
                deeplink = new android_deeplink_1.AndroidDeeplink(this.context);
                containerUpdater = new android_container_updater_1.AndroidContainerUpdater(this.context);
                return [2, player.initialise().then(function () {
                        _this.device = {
                            player: player,
                            input: input,
                            deviceInfo: deviceInfo,
                            capabilities: capabilities,
                            storage: storage,
                            lifecycle: lifecycle,
                            deeplink: deeplink,
                            containerUpdater: containerUpdater,
                        };
                        _this.initialised = true;
                    })];
            });
        });
    };
    return AndroidDeviceFactory;
}());
exports.AndroidDeviceFactory = AndroidDeviceFactory;
